/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2022-01-19 11:28:18
 * @LastEditors: zhanghang
 * @LastEditTime: 2022-01-19 13:56:09
 */
export default ['#5B8FF9','#5AD8A6','#5D7092','#F6BD16','#E8684A','#6DC8EC','#9270CA','#FF9D4D','#269A99','#FF99C3']